import { render, staticRenderFns } from "./TransferInCouncilReview.vue?vue&type=template&id=7c95fb2c&"
import script from "./TransferInCouncilReview.vue?vue&type=script&lang=js&"
export * from "./TransferInCouncilReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports